import "react-app-polyfill/stable";
import React, { useState } from "react";
import { getStore } from "./store";
import { Provider } from "react-redux";
import { MemoryRouter } from "react-router-dom";
import { RootView } from "./features/RootView";
import { GlobalStyle } from "./styling/global";
import "./styling/fonts.css";
import testPaymentProps from "./test/testPaymentProps";
import { IntlProvider } from "react-intl";
import { messages } from "./translations/messages";
import { TranslationContext } from "./contexts/TranslationContext";
import { initCybersourceFingerprint } from "./cybersource";
import { PAYMENT_METHODS__ROOT } from "./features/Routes";

function App() {
  const store = getStore();
  const [lang, setLang] = useState("en");
  const memoizedLang = React.useMemo(() => ({ lang, setLang }), [lang]);

  let entries: string[] = [];

  const currentPath = window.location.pathname + window.location.search;

  // If current path includes /revpay, use it. Otherwise use default
  if (currentPath.startsWith("/revpay")) {
    entries = [currentPath];
  } else {
    entries = [PAYMENT_METHODS__ROOT];
  }

  if (!(window as any).iswPaymentProps) {
    (window as any).iswPaymentProps = testPaymentProps;
  }

  initCybersourceFingerprint(window.iswPaymentProps);

  return (
    <>
      <GlobalStyle />
      <Provider store={store}>
        <TranslationContext.Provider value={memoizedLang}>
          <IntlProvider locale={lang} messages={messages[lang]}>
            <MemoryRouter initialEntries={entries} initialIndex={0}>
              <RootView />
            </MemoryRouter>
          </IntlProvider>
        </TranslationContext.Provider>
      </Provider>
    </>
  );
}
export default App;
